import { initGlobals } from './state/action'
import * as selector from './state/selector'

export default {
    action: {
        initGlobals,
    },
    selector,
}



// WEBPACK FOOTER //
// ./src/modules/globals/index.js